var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaintingDecoration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#683a3d;}.cls-2{fill:#ebf3f9;}.cls-3{fill:#f1afc6;}.cls-4{fill:#e7f3f8;}.cls-5{fill:#e5ce8b;}.cls-6{fill:#fcd385;}.cls-7{fill:#fcdea3;}.cls-8{fill:#914147;}.cls-9{fill:#c08c9e;}.cls-10{fill:#c9a86a;}.cls-11{fill:#c7dbf2;}.cls-12{fill:none;mask:url(#mask);}.cls-13{fill:#fff;fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 15.87,
    width: 78.79,
    height: 45.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    className: "cls-13",
    points: "0 15.87 78.79 15.87 78.79 61.64 0 61.64 0 15.87"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-1",
    points: "30.76 18.4 4.79 33.65 47.9 59.24 74.63 43.99 30.76 18.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-1",
    points: "30.89 18.4 30.89 23.82 47.91 33.65 51.81 43.99 63.11 50.56 74.63 43.99 30.89 18.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-1",
    points: "47.9 33.65 25.71 46.07 9.18 36.25 30.88 23.82 47.9 33.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-1",
    d: "m74.28,58.57l-16.59-15.41c-.78-.78-2.06-.78-2.84,0-.79.79-.79,2.06,0,2.84l16.59,15.41c.78.79,2.05.79,2.84,0,.78-.78.78-2.06,0-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-1",
    d: "m74.48,58.85c.79.79.79,2.06,0,2.84-.78.79-2.06.79-2.84,0-.79-.78-.79-2.06,0-2.84s2.06-.78,2.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-1",
    d: "m74.87,78.2c.86,1.81.55,3.75-.68,4.33-1.23.58-2.92-.42-3.77-2.23-.85-1.81-.55-3.75.68-4.33,1.23-.58,2.92.42,3.77,2.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    className: "cls-6",
    points: "75.89 50.93 75.89 56.28 47.46 72.41 47.46 66.55 75.89 50.93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    className: "cls-7",
    points: "78.79 43.99 30.89 15.87 0 33.65 47.9 61.64 78.79 43.99"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    className: "cls-4",
    points: "30.76 18.4 4.79 33.65 47.9 59.24 74.63 43.99 30.76 18.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    className: "cls-11",
    points: "30.89 18.4 30.89 23.82 47.91 33.65 51.81 43.99 63.11 50.56 74.63 43.99 30.89 18.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-11",
    className: "cls-4",
    points: "47.9 33.65 25.71 46.07 9.18 36.25 30.88 23.82 47.9 33.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-12",
    className: "cls-11",
    points: "30.89 23.82 18.28 30.97 47.91 33.65 30.89 23.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    className: "cls-7",
    points: "47.9 66.81 78.79 49.28 78.79 43.99 47.9 61.64 47.9 66.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-14",
    className: "cls-5",
    points: "0 33.65 47.9 61.64 47.9 66.81 0 39.32 0 33.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    className: "cls-3",
    d: "m33.82,50.93s.28-1.46,1.29-.7c1.01.76,1.32,1.45,2.14,1.26.82-.19.31-2.46.31-2.46l-1.07-4.03s-.13-1.83,1.22,0l2.81,2.85s1.45,1.41,1.58,0c.12-1.4,0-3.17,0-3.17,0,0,.38-1.56,1.76-.5,0,0,1.39,2.64,2.58,2.07,1.2-.57.63-2.27.63-2.27l-1.39-4.73s-.31-2.33,1.01-1.07c1.32,1.26,2.58,4.79,2.58,4.79,0,0,1.58,1.99,2.58,1.69,1.01-.3,1.07-1.5,1.07-1.5v-2.96s-1.39-2.4-.57-2.77c.82-.38,2.65,1.76,2.65,1.76l3.59,4.79s1.45,2.71,2.33,1.32c.88-1.39,1.13-1.32,1.13-1.32,0,0-.06,3.53.57,4.16.63.63,1.29,1.94,1.29,1.94l-15.89,9.38-14.23-8.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    className: "cls-8",
    d: "m74.28,58.57l-16.59-15.41c-.78-.78-2.06-.78-2.84,0-.79.79-.79,2.06,0,2.84l16.59,15.41c.78.79,2.05.79,2.84,0,.78-.78.78-2.06,0-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    className: "cls-1",
    d: "m74.48,58.85c.79.79.79,2.06,0,2.84-.78.79-2.06.79-2.84,0-.79-.78-.79-2.06,0-2.84s2.06-.78,2.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    className: "cls-2",
    d: "m74.58,61.91c-.64.51-1.57.41-2.08-.23-.51-.64-.41-1.57.23-2.08.64-.51,1.57-.41,2.08.23.51.64.41,1.57-.23,2.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    className: "cls-10",
    points: "3.08 41.09 47.46 66.55 47.46 72.41 3.08 46.7 3.08 41.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    className: "cls-3",
    d: "m99.51,63.39c-.85-1.81-2.54-2.81-3.77-2.23l-24.65,14.81c-1.23.58-1.53,2.52-.68,4.33.86,1.81,2.54,2.81,3.77,2.23l24.65-14.81c1.23-.58,1.53-2.52.68-4.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    className: "cls-9",
    d: "m74.87,78.2c.86,1.81.55,3.75-.68,4.33-1.23.58-2.92-.42-3.77-2.23-.85-1.81-.55-3.75.68-4.33,1.23-.58,2.92.42,3.77,2.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    className: "cls-2",
    d: "m74.81,59.83l5.27,5.46s.72,1.23-.41,2.08c-1.13.85-13.8,7.91-13.8,7.91,0,0-.95.69,0,1.92.94,1.23,2.14,3.21,2.14,3.21l2.74-1.76s1.07-.63,1.61,0c.54.63.22,1.35.22,1.35l-4.38,3.06s-1.5.57-2.75-1.76c-1.25-2.33-2.63-4.6-2.63-4.6,0,0-.85-2.05,1.73-3.4,2.58-1.35,12.35-6.99,12.35-6.99l-4.53-4.81,2.43-1.67Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintingDecoration);
export default __webpack_public_path__ + "static/media/painting-decoration.37a9f7227dc5722421f73559d30e6e9d.svg";
export { ForwardRef as ReactComponent };